/* pg-marquee */
(function(){
  if (window.pgMarquee) return; window.pgMarquee = 1;

  function fill(track){
    var kids = Array.prototype.slice.call(track.children);
    if (kids.length < 2) return;

    /* First sight: the track is marq()'s two identical halves, so one message
       set is the first half. Cache both the markup and how many elements it
       is, because after a rebuild neither can be inferred from the DOM. */
    var unit = track.dataset.pgUnit;
    var unitCount = parseInt(track.dataset.pgUnitCount || '0', 10);
    if (!unit){
      if (kids.length % 2 !== 0) return;         /* not the two-half shape */
      unitCount = kids.length / 2;
      unit = kids.slice(0, unitCount).map(function(el){ return el.outerHTML; }).join('');
      track.dataset.pgUnit = unit;
      track.dataset.pgUnitCount = String(unitCount);
    }
    if (!unitCount || kids.length < unitCount) return;

    /* always exactly one set, however many are on screen now */
    var per = 0;
    for (var i = 0; i < unitCount; i++) per += kids[i].offsetWidth;
    if (!per) return;

    /* copies of the set needed for one half to cover the screen, plus margin */
    var need = Math.max(1, Math.ceil((window.innerWidth + 120) / per));
    if (track.dataset.pgNeed === String(need)) return;
    track.dataset.pgNeed = String(need);

    var half = new Array(need + 1).join(unit);
    track.innerHTML = half + half;
  }

  function pass(){
    document.querySelectorAll('.pg-marq').forEach(fill);
  }

  function boot(){
    pass();
    /* marq() runs on its own delay, so catch the track once it exists */
    [300, 900, 1800, 3000].forEach(function(t){ setTimeout(pass, t); });
    window.addEventListener('resize', pass);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
